import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon } from "semantic-ui-react";
import auth from "../../services/authService";

class PhotoTable extends Component {
  columns = [
    {
      path: "name",
      label: "Name",
      width: "14"
    },
    {
      key: "actions",
      width: "2",
      content: type =>
      //auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && (
          <div>
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />

            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </div>
       // )
    }
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default PhotoTable;
